import { jwtDecode } from "jwt-decode";

/**
 * Session de l'utilisateur connecté, lue depuis le JWT stocké par Login.js
 * (localStorage "token") : `null` si absent, illisible ou expiré.
 * `role` vaut INDIVIDUAL pour un particulier (schéma non_company).
 */
export const currentSession = () => {
    let token = null;
    try {
        token = localStorage.getItem("token");
    } catch {
        return null;
    }
    if (!token) return null;
    try {
        const claims = jwtDecode(token);
        if (claims.exp && claims.exp * 1000 <= Date.now()) return null;
        return { token, role: claims.role, userId: claims.user_id, tenantCode: claims.tenant_code };
    } catch {
        return null;
    }
};

export const INDIVIDUAL_ROLE = "INDIVIDUAL";

/**
 * Mot de passe reçu par email jamais changé (claim `password_change_required` de
 * schema-based-tenant-management) : l'utilisateur doit le changer d'urgence.
 */
export const passwordChangeRequired = (token) => {
    if (!token) return false;
    try {
        const claims = jwtDecode(token);
        if (claims.exp && claims.exp * 1000 <= Date.now()) return false;
        return claims.password_change_required === true;
    } catch {
        return false;
    }
};
